<template lang="html">
    <div class="container">
        <div class="page-header">
            <h1>{{bookInfo.name}} <span v-html="qrcode"></span></h1>
        </div>
        <div v-for="unit in unitList.list" class="panel panel-info">
            <div class="panel-heading">
                <h3 class="panel-title">{{unit.name}}
                    <button @click="loadPPT(unit.id)" class="btn btn-default btn-xs">展开ppt列表</button>
                </h3>
            </div>
            <div v-show="selected.unit.id==unit.id" class="panel-body">
                <div v-for="PPT in PPTList.list" class="col-md-6">
                    <div class="ppt-block">
                        <img :src="PPT.logo" :alt="PPT.name" @error="imgError($index)">
                        <p>{{PPT.name}}</p>
                        <div class="ppt-button">
                            <a v-show="wyrole!='YES'" class="btn btn-default " @click="noAllow">下载</a>
                            <a v-else class="btn btn-default " :href="PPT.pptUrl" target="_blank">下载</a>
                            <button @click="openPPTmodal($index)" class="btn btn-default ">预览</button>
                        </div>
                    </div>
                </div>
                <page :turn-page="pageOpt.ppt"></page>
            </div>

        </div>
        <page :turn-page="pageOpt.unit"></page>

        <!-- PPT-Modal -->
        <div class="modal ppt-modal fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
            <div class="modal-dialog" style="width: 700px">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal"><span aria-hidden="true">&times;</span><span
                            class="sr-only">Close</span></button>
                        <h4 class="modal-title" id="myModalLabel">{{modal.ppt.name}}</h4>
                    </div>
                    <div class="modal-body">
                        <div class="swiper-container">
                            <div class="swiper-wrapper">
                                <div v-for="one in modal.ppt.pptImages" class="swiper-slide"><img :src="one" alt="">
                                </div>
                            </div>
                            <div class="swiper-button-prev"></div>
                            <div class="swiper-button-next"></div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-default" data-dismiss="modal">关闭</button>

                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
    var qrCode = require('qrcode-npm')
    require('swiper');
    import M from '../assets/common.js'
    import C from '../assets/config.js'
    import qiniu from '../components/qiniu'
    import page from '../components/page.vue'

    export default {
        components: {
            qiniu,
            page
        },
        events: {
            'child-qiniu-data': function (data) {
                let url = data.domain + data.key
                if (data.callbackType == 'FileUploaded') {
                    if (data.picType == "img") {
                        this.modal.ppt.pptImages.push(url)
                    } else {
                        this.$set('modal.ppt.pptUrl', url)
                    }
                }
            }
        },
        data: () => ({
            host: C.host,
            urlParams: M.getUrlParams(location.href),
            bookInfo: {},
            unitList: {},
            PPTList: {},
            selected: {
                unit: {}
            },
            modal: {
                unit: {},
                ppt: {
                    pptImages: []
                },
                del: {}
            },
            typeName: {},
            qrcode: '',
            pageOpt: {
                ppt: {
                    type: 'ppt',
                    pageNo: 1,
                    pageSize: 10,
                },
                unit: {
                    type: 'unit',
                    pageNo: 1,
                    pageSize: 10,

                }
            },
            wyrole: localStorage.getItem('wyrole'),
        }),
        created: function () {
            this.loadUnit();
            this.loadBook();
            let self = this;
            M.getAllType("admin", function (data) {
                self.$set('typeName', data);
                self.getQrcode();
            })

        },
        events: {
            'child-turn-page': function (data) {
                this.turnPage(data);
            }

        },
        methods: {
            imgError: function (index) {
                this.$set('PPTList.list[' + index + '].logo',
                    'http://qiniu.ludanmall.com/472/commend/logo/千库网-素材书图片_1480562667018.png');
            },
            noAllow: function () {
                M.topRightInfoTips({
                    content: '权限不足'
                })
            },

            getQrcode: function () {
                let qr = qrCode.qrcode(4, 'M');
                qr.addData("http://www.scwywh.com/mobile.html#/pptInfo?id=" + this.urlParams.id);
                qr.make();
                let code = qr.createImgTag(4)
                this.qrcode = code;
            },
            // 查询书籍
            loadBook: function () {
                let url = this.host + "wuyan/user/book/" + this.urlParams.id,
                    params = {},
                    self = this;
                M.load(url, params, function (data) {
                    if (data.code) {
                        alert(data.message);
                    } else {
                        self.$set("bookInfo", data.data);

                    }

                }, 'get');
            },
            //查询单元
            loadUnit: function () {
                let url = this.host + "wuyan/user/unit",
                    params = {
                        bookId: this.urlParams.id,
                        pageNo: this.pageOpt.unit.pageNo,
                        pageSize: this.pageOpt.unit.pageSize

                    },
                    self = this;
                M.load(url, params, function (data) {
                    if (data.code) {
                        M.topRightInfoTips({
                            content: data.message
                        });
                    } else {
                        self.$set('unitList', data.data);
                        self.$set('pageOpt.unit', {
                            pageNo: data.data.pageNo,
                            pageSize: data.data.pageSize,
                            totalCount: data.data.totalCount,
                            type: self.pageOpt.unit.type
                        });
                        if (self.unitList.list.length > 0) {
                            self.loadPPT(self.unitList.list[0].id);


                        }
                        self.$log();
                    }
                }, 'get')
            },


            //查询ppt
            loadPPT: function (id) {
                if (id != "page") {
                    this.$set("selected.unit.id", id)
                }
                let url = this.host + "wuyan/admin/course",
                    params = {
                        unitId: this.selected.unit.id,
                        pageNo: this.pageOpt.ppt.pageNo,
                        pageSize: this.pageOpt.ppt.pageSize

                    },
                    self = this;
                M.load(url, params, function (data) {
                    if (data.code) {
                        M.topRightInfoTips({
                            content: data.message
                        });
                        self.$set('PPTList.list', [])
                    } else {
                        self.$set('PPTList', data.data);
                        self.pageOpt.ppt.pageNo = data.data.pageNo;
                        self.$set('pageOpt.ppt.totalCount', data.data.totalCount);
                        self.$set('pageOpt.ppt.type', 'ppt');
                    }

                }, 'get');
            },
            // 打开pptModal
            openPPTmodal: function (index) {
                let vm = this;
                this.$set('modal.ppt', JSON.parse(JSON.stringify(vm.PPTList.list[index])));
                this.$set('modal.ppt.pptImages', JSON.parse(this.PPTList.list[index].pptImages));
                this.$log();
                $('.ppt-modal').modal('show');

                this.$nextTick(function () {
                    var mySwiper = new Swiper('.swiper-container', {
                        prevButton: '.swiper-button-prev',
                        nextButton: '.swiper-button-next',
                    })

                })
            },
            //翻页
            turnPage: function (data) {
                if (data.type === 'ppt') {
                    this.pageOpt.ppt = data;
                    this.loadPPT('page');
                } else if (data.type === 'unit') {
                    this.pageOpt.unit = data;
                    this.loadUnit();
                }
            }


        }
    }
</script>
<style scoped>
    td img {
        max-width: 50px;
        max-height: 50px
    }

    .form-group p {
        margin: 0;
        padding: 8px;
    }

    .swiper-slide img {
        width: 100%;
        max-height: 100%;
    }

    .ppt-block {
        border: 1px solid rgba(0, 0, 0, 0.1);
        padding: 5px
    }

    .ppt-button {
        text-align: right
    }

</style>


// WEBPACK FOOTER //
// workInfo.vue?3ed188cc